import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Dashboard from "./pages/Dashboard/Dashboard";
import Registration from "./pages/Dashboard/registration/Registration";
import Clients from "./pages/Dashboard/sections/Clients";
import Overview from "./pages/Dashboard/sections/overview/Overview";
import Profile from "./pages/Dashboard/sections/Profile";
import TherapistProfile from "./pages/Dashboard/sections/therapistProfile/TherapistProfile";
import Therapists from "./pages/Dashboard/sections/Therapists";

import Home from "./pages/Home/Home";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route index path="/" element={<Home />} />
          <Route
            path="/registration"
            element={<Dashboard Component={Registration} />}
          />
          <Route
            path="/therapists"
            element={<Dashboard Component={Therapists} />}
          />
          <Route
            path={"/therapist/:therapistUID"}
            element={<Dashboard Component={TherapistProfile} />}
          />
          <Route
            path={"/profile/:uid"}
            element={<Dashboard Component={Profile} />}
          />
          <Route
            path={"/overview"}
            element={<Dashboard Component={Overview} />}
          />
          <Route
            path={"/clients"}
            element={<Dashboard Component={Clients} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
